export const language = {
  en:{
    tmsConnectionFailed:'Failed to connect TMS server',
    counterSignin:'Signed into the counter successfully',
    confirmMessage:'Are you sure want to delete?',
    logoutMessage : 'Are you sure want to logout?',
    unableDelete : 'Unable to delete',
    unableSubmit : 'Unable to submit',
    deleteMsg : 'deleted successfully',
    invalidExcel : 'Invalid excel file',
    processFirst : 'Please select process first', 
    process : 'Please select process',
    userRole : 'Please select user role',
    selectFingerindex : 'Please select finger index and try again',
    cliPDFmessage:'PDFs generated and saved successfully',
    unableConnect : 'Unable to connect secugen device',
    minFinger: 'Kindly upload minimum three fingerprints',
    captureCode : 'Fingerprint capture error code: ',
    description : '.\nDescription:  ',
    matchFinger : 'Fingerprint details are matched successfully',
    incorrectFinger : 'Incorrect fingerprint details',
    matchingFailed : 'Failed to match the template',
    codeVerify : 'Your code has successfully verified',
    codeSent : 'The verification code has been sent to your registered email address',
    codeErr : 'Error in sending code',
    contactAdmin : 'Please contact your administrator',
    confirmMessage1:'Your session is about to expire.Do you need more time?',
    unableConnectSign : 'Unable to connect device',
    getSign : 'Please get the signature from the applicant',
    SelectDoc:'Select document type for document #',
    SelectDocName:'Enter document name for document #',
    uploadVaccinationDoc:'you are not selected the vaccination in place order. So, you need to upload the document against the vaccination, Are you still want to continue without the document?',
    generation :'Please select atleast all specimen generation to continue',
    collection :'Please select atleast all specimen collection to continue',
    skipToken : 'Please call next token and try to skip',
    reassignToken : 'Please call next token and try to assign',
    recall : 'Cannot access the skip button while in the recall process',
    vaccineMsg:'Do you want to save this vaccine information?',
    noRecord:'No record found',
    refusalContinue:'Do you want to continue refusal process?',
    refusalContinueGRO:'It since if signature have not collected from the applicant, Do you want to continue refusal process?',
    clinicalFit:'Do you want to continue as Save, Patient is selected as clinically fit?', 
    clinicalNotFit:'Do you want to continue as Save, Intermediate Referral is initiated?',
    noReferral:'No referral initiated for this applicant',
    confirmReferralClose:'Are you sure wants to close this referral?',
    confirmReferralReopen:'Are you sure wants to reopen this referral?',
    uploadDoc:'Kindly upload the document',
    vaccinationDocMissing:'Vaccination document is missing',
    retestConfirm:'Please confirm retest for ',    
    //new line
    cancel_confirmMessage:"Are you want to cancel?",

    gro:{
      //success message
      success_mes: 'Finger Captured Successfully',
      matchFinger : 'Fingerprint details are matched successfully',
      verify_success_mes:'Finger Print Verify Successfully',
      error_mes_bio:'Fingerprint capture timeout',
    // gro_dashboard
      mrg_msg:'Hello',
      vn_validate:'Validate VN',
      pn_validate:'Validate PN',
      patient_number:'Patient Number',
      bill_receipt:'Bill Receipt',
      vn_placeholder:'Visa Application Number *',
      pn_placeholder:'Patient Number *',
      br_placeholder:'Bill Receipt*',
      adjust:'Adjust',

    // gro_stepLines
      step_line1:'Patient Profile',
      step_line2:'Place Order',
      step_line3:'Capture Identity',

    // gro_pp
      personal:'Personal',
      title:'Title',
      title_err:'Please select title',
      gender:'Gender',
      gender_err:'Please select gender',
      nationality:'Nationality',
      nationality_err:'Please select nationality',
      marital_Sts:'Marital Status',
      f_Name:'First Name',
      s_Name:'Second Name',
      t_Name:'Third Name',
      fourth_Name:'Fourth Name',
      family_Name:'Family Name',
      dob:'DOB',
      Age:'Age',
      Visa_Application:'Visa Application No',
      Applicant_Believes_Pregnant:'Applicant Believes Pregnant?',
      // Applicant_Believes_Pregnant_err:'Please select anyone',
      Communication:'Communication',
      Preferred_Communication:'Preferred Communication',
      Speak:'Preferred Language to Speak',
      Speak_err:'Please select preferred language to speak',
      Read:'Preferred Language to Read',
      Read_err:'Please select preferred language to read',
      // Preferred_loc:'Preferred Location For Referral ',
      Preferred_loc_err1:'Select Country first',
      Preferred_loc_err2:'Please select preferred location',
      Preferred_hosp:'Preferred Hospital',
      Preferred_hosp_err1:'Select preferred location first',
      Preferred_hosp_err2:'Please select preferred hospital ',
      SMS_Alert_No:'SMS Alert Number',
      SMS_err1:'Enter Sms alert number',
      SMS_err2:'Please enter valid number',
      Off_Ph:'Alternative Phone Number',
      Off_Ph_err2:'Please enter alternative phone number',
      Mob_Ph :'Mobile Phone',
      Mob_Ph_err2:'Please enter mobile phone',
      Email:'Email',

      Enter_Address:'Enter Address',
      Area:'Area',
      Enter_Area:'Enter Area',
      ZIP_Code:'ZIP Code',
      Enter_ZipCode:'Enter ZipCode',
      Province:'Province',
      Enter_Province:'Enter Province',


      Encounter:'Encounter',
      Visa_Category:'Visa Category',
      Visa_Category_err:'Please select visa category',
      Agency:'Agency',
      Job_Position_err:'Please select job position',
      Driving:'Is Job applicable of Driving?',
      Previous_resident:'Previous resident of Qatar or not',
      Paid:'Paid by Mission',  

      consent_abb:'Consent Abbreviation',
      pp_save:'Save and Print',
      consent_form:'Consent Abbreviation Form',
      sign_collect:'Applicant Signature Collection',

      Refusal_Process:'Refusal Process',
      Refusal_Status:'Refusal Status',
      Refusal_Reason:'Refusal Reason',
      Applicant_Signature:'Applicant Signature',
     
      Consent_Refusal:'Consent Refusal',
      Please_select_reason:'Please select reason',
      Please_enter_comments:'Please enter comments',

      Vaccination_Refusal:'Vaccination Refusal',
      Referral_Refusal:'Referral Refusal',
      Clear:'Clear',

      yes:'Yes',
      no:'No',
      maybe:'May be',
      // pp_placeholders
      title_placeholder:'Select title',
      Gender_placeholder:'Select Gender',
      Nationality_placeholder:'Select Nationality',
      Marital_placeholder:'Select Marital status',
      fn_placeholder:'Enter FirstName',
      sn_placeholder:'Enter SecondName',
      tn_placeholder:'Enter ThridName',
      fourthN_placeholder:'Enter FourthName',
      fam_placeholder:'Enter FamilyName',
      DOB_placeholder:'Enter DOB',
      Age_placeholder:'Enter Age',
      VisaNumber_placeholder:'Enter VisaNumber',
      select_placeholder:'Select',
      country_placeholder:'Select country',
      Preferred_placeholder:'Select Preferred Communication',
      speak_placeholder:'Select Preferred Language to Speak',
      read_placeholder:'Select Preferred Language to Read',
      loc_placeholder:'Select Preferred Location',
      hosp_placeholder:'Select Preferred Hospital',
      sms_placeholder:'SMS alert number',
      off_placeholder:'Alternative phone number',
      mob_placeholder:'Mobile number',
      email_placeholder:'Enter Email',
      viseCat_placeholder:'Select Visa Category',
      agency_placeholder:'Select Agency',
      jp_placeholder:'Select Job Position',
      selectR_placeholder:'Select reason',
      cmt_placeholder:'Enter comment',

    // gro_po
      Select_Service:'Select Service',
      Type:'Type',
      Priority:'Priority',
      Amount:'Amount',
      sub_btn:'Proceed with Selection',
    

    // gro_capIdentity
      Capture:'Capture',
      noCamera:'Camera device not available',
      Passport_Number:'Passport Number',
      Passport_Number_err:'Please Enter Passport Number',
      Issued_Date:'Issued Date',
      Expiry_Date:'Expiry Date',
      expired_err:'Please Select Expiry Date',
      sel:'Select country',
      sel_err:'Please Select Country',
      Issued_At:'Issued At',
      Issued_At_err:'Please Enter Issued At',
      add_doc:'Add Documents',
      doc_type:'Document Type',
      doc_name:'Document Name',
      doc:'Document',
      sel_doc:'Select Document Type',
      vac_placeholder:'Eg. Vaccination Certificate',
      add_doc1:'Add Document',
      SaveNext:'Save and Next',
      Capture_Pic:'Capture Picture',
      Toggle:'Toggle',
      Switch_Camera:'Switch Camera',

    // gro_callCenter
      cc_heading:'Call Center Referral Log',
      cc_M_worklist:'Manager Worklist',
      fetch:'Fetching!',
      Referral_Type:'Referral Type',
      ref_type:'Select referral type',
      Ageing:'Ageing',
      sel_Ageing:'Select Ageing',
      Call_Status:'Call Status',
      Select_call:'Select call status',
      VisaAppNo:'Visa Application No',
      Referral_Date:'Referral Date',
      Next_Action_Date:'Next Action Date',
      Stage_of_Call:'Stage of Call',
      Actions:'Actions',
      
      Description:'Description',
      Number_of_Successful_Calls:'Number of Successful Calls',
      Appointment_Date:'Appointment Date',
      Overdue_Days:'Overdue Days',
      Number_of_calls:'Number of calls',
      Last_Assigned_Agent:'Last Assigned Agent',
      Last_Call_Outcome:'Last Call Outcome',
      Additional_Number:'Additional Number',
      Addtional_number:'Addtional number',
      Preferred_Speak:'Preferred Lang to Speak',
      Preferred_Read:'Preferred Lang to Read',
      Preferred_Location_for_eferral:'Preferred Location for Referral',
      Hospital_Name:'Hospital Name',
      Address:'Address',
      Attended:'Attended',
      Busy:'Busy',
      Not_Reachable:'Not Reachable',
      Wrong_Number:'Wrong Number',
      Call_Log_Updates:'Call Log Updates',
      Phone_Number:'Phone Number',
      InformationCallLogs:'Information - Call Logs',
      Appointment_Login:'Appointment Login',
      Pre_Lang:'Preferred Language',
      placeholder_speak:'Select preferred language speak',
      speak_err:'Please select preferred language',
      InboundOutbound:'Inbound/Outbound',
      Inbound:'Inbound',
      Outbound:'Outbound',
      InboundOutbound_err:'Please select inbound / outbound',
      SMS_Sent:'SMS Sent',
      Email_Sent:'Email Sent',
      sms_err:'Please check sms sent',
      Call_Date:'Call Date',
      Call_Outcome:'Call Outcome',
      Assigned_Agent:'Assigned Agent',
      External_Speciality:'External Speciality',
      Confirmatory:'Confirmatory',
      XRay:'X-Ray',
      
    // gro_specimen
      specimen_heading:'Specimen Transmittal Form',
      Labs:'Labs',
      Select_Lab:'Select Lab',
      SpecimenID:'Specimen Batch Staff ID',
      Location:'Location',
      Generated_Date:'Generated Date',
      Collected_Date:'Collected Date',
      serialNo:'Serial No.',
      ExtID:'Ext Specimen ID',
      Container:'Container / Vacutainer',
      CollectedOn:'Collected On',
      Container_:'Container',

    // gro_refusalToContinue
       RefuseToContinue:'Refusal to Continue Report',
       Date_Time:'Date and Time',
       Call_Centre_Informed:'Call Centre Informed',
       MOI_Informed:'MOI Informed',

    // exit_process
      Exit_Check_Process_Report:'Exit Check Process Report',
      Ext_Scan_Date_Time:'Ext Scan Date Time',
      Final_Status:'Final Status',
      GRO_Process:'GRO Process',
      Nurse_Process:'Nurse Process',
      XRay_Process:'X-Ray Process',
      GP_Process:'GP Process',
      Action_Required:'Action Required',
     

      // GRO Referral print letter
      GRO_Referral_Call_Log:'GRO Referral Call Log',
      Print_Referral_Letter:'Print Referral Letter',
      Upload_Referral_Document:'Upload Referral Document',
      Print_Receipt:'Print Receipt',
      Refused_continue:'Refused to continue',
      Please_select_refusal_reason:'Please select refusal reason',
      Please_select_signature:'Please select signature',

      //upload document
      document_upload:'Document upload is allowed only for Referrals (Document Type) for which referral letter printed',
      Uploaded_Referral_Document:'Uploaded Referral Document',
      Please_enter_document_name:'Please enter document name',
      Upload_Document:'Upload Document',
      Browse:'Browse',

      //gro breadcrumb
      Print_Referral_Document:'Print Referral Document',
      Upload_Referral:'Upload Referral',
      Exit_Process_Report:'Exit Check Process Report',
      Refusal_Continue:'Refusal to Continue Report',
      Specimen_Form:'Specimen Transmitted Form',
      Call_Center_Referral:'Call Center Referral',
      VN_Registration:'VN Registration',
      Referral_Call:'Referral Call Log',
      Staff_Dashboard:'GRO Staff Dashboard',
     
    },

  nurse:{
    Record_Vitals:'Record Vitals',
    Specimen_Generation:'Specimen Generation',
    Specimen_Collection:'Specimen Collection',
    Vaccination:'Vaccination',
    //Record vitals
    Body_Mass_Index:'Body Mass Index',
    Height:'Height',
    height_placeholder:'Enter Height',
    height_err1:'Please enter Height',
    height_err2:'Maximum 3 digits allowed',
    height_err3:'Please enter your correct height',
    Weight:'Weight',
    weight_placeholder:'Enter Weight',
    weight_err1:'Please enter Weight',
    weight_err2:'Maximum 3 digits allowed',
    weight_err3:'Please enter your correct weight',
    BMI:'BMI',
    bmi_placeholder:'Enter your BMI',
    Out_of_range:'Out of range',
    Vision:'Vision',
    Right_Vision:'Right Vision',
    r_vision_err:'Please select Right Vision',
    Left_Vision:'Left Vision',
    l_vision_err:'Please select Left Vision',
    Color_Vision:'Color Vision',
    Poor:'Poor',
    Normal:'Normal',
    ColorV_err:'Check any one color vision',
    Color_Plates:'Color Plates',
    Color_Plate:'Color Plate',
    Color_Plate_err:'Please select Color Plate',
    Select_color_plate:'Select color plate',
    bp:'Blood Pressure',
    sp:'Systolic Pressure',
    sp_err1:'Please enter Systolic Pressure',
    height_err:'Please enter correct height',
    weight_err:'Please enter correct weight',
    Select_Right_Vision:'Select Right Vision',
    Select_Left_Vision:'Select Left Vision',

    dp:'Diastolic Pressure',
    dp_err1:'Please enter Diastolic Pressure',
    Systolic:'Systolic',
    Diastolic:'Diastolic',
    
    Order_ID:'Order ID',
   //Generate Specimen
    Generate_Specimen:'To Generate Specimen',
    Show_barcode:'Show Barcode',
    collection:'of Vacutainer to camera post - collection',
    Immediately_Place:'Immediately Place',
    codeTocamera:'Vacutainer only in sample collection box showing bar code to camera',
    takeSampel:'Do not Take Sample in Non Barcoded Vacutainer and sample with syringe and needle',
    
    Generate_Specimen1:'Generate Specimen',
    Container:'Container',
    Action_By:'Action By',
    Barcode_Print_Request:'Barcode Print Request',
    Collected:'Collected',

  // vaccine
    Vaccine_Given:'Vaccine Given By Nurse?',
    Select_option:'Select an option',
    Select_option_err:'Please select vaccine status',
    batch_no:'Enter batch number',
    batch_no_err1:'Please enter batch number',
    batch_no_err2:'Please enter minimum 12 digit batch number',
    batch_no_err3:'Please enter Valid batch number',
    Document:'Document',
    Generate_Voucher:'Generate Voucher',
    pls_wait:'Please wait...',
    
  // sample_out
    Sample_outgoing:'Sample Outgoing',
    Priority:'Priority',
    Sel_priority:'Select priority',
    LabGRO:'Lab Technician and GRO info',
    Lab_Tech_Name:'Lab Tech Name',
    Select_Lab_Tech_name:'Select Lab Tech name',
    Please_select_lab_technician:'Please select lab technician',
    GRO_Name:'GRO Name',
    Select_GRO_name:'Select GRO name',
    Please_select_GRO:'Please select GRO',
  // barcode_reprint
    Barcode_Printing_Request:'Barcode Printing Request',
    Patient_Number:'Patient Number',
    Name:'Name',
    Print:'Print',

    // nurse breadcrumb
    Barcode_reprint:'Barcode reprint',
    Nursing_Process:'Nursing Process'
},

gp:{
  // Nursing_outcome
    Nursing_Outcome:'Nursing Outcome',
    Consultation:'Consultation',
    VITAL_INFORMATION:'VITAL INFORMATION',
    VACCINE_INFORMATION:'VACCINE INFORMATION',
    batch_no:'Enter batch number',
    Vaccine_Document:'Vaccine Document',
    Captured_Date:'Captured Date',
    Captured_By:'Captured By',
    Client_Worklist:'Client Worklist',
   //consultation
    Preset:'Preset',
    Select_preset:'Select preset',
    Normal:'Normal',
    Abnormal:'Abnormal',
    Please_select_preset:'Please select preset',
    Cardiovascular_System:'Cardiovascular System',
    Enter_Cardiovascular_System:'Enter Cardiovascular System',
    Cardiovascular_System_is_required:'Cardiovascular System is required',
    add:'add',
    Deformity:'Deformity',
    Deformity_System_is_required:'Deformity System is required',
    Respiratory_System:'Respiratory System',
    Respiratory_System_is_required:'Respiratory System is required',
    Deformities:'Deformities',
    Deformities_is_required:'Deformities is required',
    Gastro_Intestinal_System:'Gastro Intestinal System',
    Gastro_required:'Gastro Intestinal System is required',
    Skin:'Skin',
    Skin_required:'Skin is required',
    Eye:'Eye',
    Eye_required:'Eye is required',
    Venereal_Diseases:'Venereal Diseases',
    Enter_Veneral_Diseases:'Enter Veneral Diseases',
    Veneral_Diseases_required:'Veneral Diseases is required',
    Ear:'Ear',
    Ear_required:'Ear is required',
    CNS:'CNS',
    Enter_CNS:'Enter CNS',
    CNS_required:'CNS is required',
    Hernia:'Hernia',
    Enter_Hernia:'Enter Hernia',
    Hernia_required:'Hernia is required',
    Psychiatry:'Psychiatry',
    Enter_Psychiatry:'Enter Psychiatry',
    Psychiatry_required:'Psychiatry is required',
    Varicose_Veins:'Varicose Veins',
    Enter_Varicose_Veins:'Enter Varicose Veins',
    Varicose_Veins_required:'Varicose Veins is required',
    Other_Referral:'Other Referral - For Any Medical History Please Raise Referral Here',
    Enter_Referral_Remark:'Enter Referral Remark',
    Other_required:'Other referral is required',
    Extremities:'Extremities',
    Enter_Extremities:'Enter Extremities',
    Extremities_required:'Extremities is required',
    Random_sample:'Random Sample',
    Enter_Random_sample:'Enter Random sample',
    Random_sample_required:'Random sample is required',
    Clinical_Fit:'Clinical Fit',
    Medical_History:'Medical History',
    Previous_Illness:'Previous Illness',
    Please_enter_previous_illness:'Please enter previous illness',
    your_meals:'Did you have your meals in last 10 hours?',
    Psychiatric_or_Neurological_Disorder:'Psychiatric or Neurological Disorder',
    Please_enter_disorder:'Please enter psychiatric or neurological disorder',
    Allergies:'Allergies',
    Drugs:'Drugs',
    drugs_allergies:'Please mention drugs allergies',
    Dust:'Dust',
    dust_allergies:'Please mention dust allergies',
    Food:'Food',
    food_allergies:'Please mention food allergies',
    Fumes:'Fumes',
    fumes_allergies:'Please mention fumes allergies',
    other_allergies:'Please mention the any other allergies',
    Previous_Referrals:'Previous Referrals',
    Speciality:'Speciality',
    Action_Date:'Action Date',
    Clinical_notes:'Clinical Notes',
    Referral_Letter:'Referral Letter',
    View:'View',
    Edit:'Edit',
    Delete:'Delete',
    Intermediate_Referral:'Intermediate Referral',
    select_speciality:'Please select speciality',
    select_action_date:'Please select action date',
    select_future_dates:'Please select the future dates',
    Clinical_Notes:'Clinical Notes',
    Enter_Notes:'Enter Notes',
    enter_clinical_notes:'Please enter clinical notes',
    Referrals_Created:'Referrals Created',
    Total_Referrals_Created:'Total Referrals Created',
    Referral_No:'Referral No',
    No_referrals:'No referrals were created',
    Go_To_Feedback:'Go To Feedback',
    Vitals_History:'Vitals History',
    //other-referral
    Other_Document_Name:'Other Document Name',
    Other_Document_Type:'Other Document Type',
    Created_On:'Created On',
    //physician worklist
    Physician_Worklist:'Physician Worklist',
    Ready_to_Consult:'Ready to Consult',
    Referral_Reported:'Referral to be Reported',
    Registered_Date:'Registered Date',
    Previous_Assign_User:'Previous Assigned User',
    Assign_User:'Assigned User',
    Physician:'Physician',
    Doctor_Report:'Doctor Report',
    //annual physical examination
    Annual_Physical_Examination:'Annual Physical Examination',
    Ecg_Worklist:'ECG Worklist',
    Usg_Worklist:'USG Worklist',
    Tmt_Worklist:'TMT Worklist',
    Echo_Worklist:'ECHO Worklist',
    Xray_Worklist:'X-RAY Worklist',
    Audiometry_Worklist: 'Audiometry Worklist',
    APE_Summary_Report: 'APE Summary Report',
    Summary_Report:'Summary Report',
    Service_Report:'Biometric Applicant',
    Dental_Worklist:'Dental Worklist',
    //critical notification
    Critical_Notification:'Critical Notification',
    SampleType_TestName:'Sample Type/Test Name',
    Panic_Value:'Panic Value',
    //certiticate
    Vitals:'Vitals',
    VITALS:'VITALS',
    WARNING:'WARNING',
    FIT:'FIT',
    AWAITING:'AWAITING',
    Lab:'Lab',
    LAB:'LAB',
    Radiology:'Radiology',
    RADIOLOGY:'RADIOLOGY',
    CONSULTATION:'CONSULTATION',
    Total_Referrals_issued:'Total Referrals issued',
    Referrals_Closed:'Referrals Closed',
    Referrals_Open:'Referrals Open',
    Referral_Ready_Review:'Referral Ready to Review',
    View_Referral_Document:'View Referral Document',
    Medical_Report:'Medical Report',
    Owner:'Owner',
    Issue_Referral:'Issue Referral',
    Lab_Report:'Lab Report',
    CREATE_REFERRAL:'CREATE REFERRAL',
    Physician_Name:'Physician Name',
    Previous_Brief_History:'Previous Brief History',
    Save_Intermediate:'Do you want to continue as Save, Intermediate',
    Referral_initiated:'Referral is initiated?',
    InformationLab:'Information - Lab',
    Lab_Confirmatory:'Lab Confirmatory',
    Additional_XRay:'Additional X-Ray',
    ABNORMALITES_CAPTURED:'ABNORMALITIES CAPTURED',
    Vital_Information:'Vital Information',
    Consultation_Information:'Consultation Information',
    Lab_Information:'Lab Information',
    XRay_Information:'X-Ray Information',
    //referral document
    No_referral_documents_found:'No referral documents were found',
    Referral_Consultation_Document:'Referral Consultation Document',
    Referral_Reopen:'Referral Reopen',
    BP:'BP',
    Add_Vitals:'Add Vitals',
    //status tab
    Other_Document:'Other Document',
    //gp breadcrumb
    NurseOutcome:'Nurse-Outcome',
    Certificate:'Certificate',
    Create_Referral:'Create Referral',
    // Consultation_Process:'Consultation Process',
    Doctor_Referral_Process:'Doctor Referral Process',
    Referral_Report:'Referral Report'
  },

lab:{
  //speciemn inscan
  Specimen_Inscan_Process:'Specimen Inscan Process',
  Counter:'Counter',
  Select_counter:'Select Counter',
  Lab_ID:'Lab ID',
  Collected_DateTime:'Collected Date & Time',
  Collected_By:'Collected By',
  Outgoing_DateTime:'Outgoing Date & Time',
  Outgoing_By:'Outgoing By',
  Accepted_RejectedOn:'Accepted/Rejected On',
  Accepted_RejectedBy:'Accepted/Rejected By',
  Lab_Tests_Specimen:'Lab Tests for Specimen',
  Reason_reject_specimen:'Reason for reject specimen',

  //Lab Worklist
  Lab_Worklist:'Lab Worklist',
  Accepted_By:'Accepted By',
  Interface_Date:'Interface Date & Time',
  Result_Entry:'Result Entry',
  Spec_No:'Spec. No',
  Analyzer_Name:'Analyser Name',
  Result:'Result',
  Cut_Off:'Cut Off',
  Units:'Units',
  Normal_Range:'Normal Range',
  Is_Normal:'Is Normal',
  First_Review:'First Review',
  Submit_First_Review:'Submit for First Review',
  Lab_Tests_Details:'Lab Tests Details',
  Run_Code:'Run Code',
  Result_Units:'Result Units',
  Resulted_DateTime:'Resulted Date & Time',
  //rejected worklist
  Rejected_Worklist:'Rejected Worklist',
  //lab senior-lab review
  Submit_for_Review:'Submit for Review',
  //lab director (lab amend report) 
  Amend_Report:'Amend Report',
  Request_Date_Time:'Request Date & Time',
  Request_By:'Request By',
  Request_Reason:'Request Reason',
  Information:'Information',
  mapBarcode: 'Map Barcode',
  
 //lab supervisor(pathalogist)
 Pathalogist_Worklist:'Pathologist Worklist',
 Authorize_All:'Authorize All',
 Submit_for_Authorizer:'Submit for Authorizer',
 Amend_Reason:'Amend Reason',
 Select_qualitative_type:'Select qualitative type',

 //trf
 Test_Requisition_Form:'Test Requisition Form',
 Print_TRF:'Print TRF',
 VNR_NO:'VNR NO',
 Specimen_Information:'Specimen Information',
 Sample_Collectedby:'Sample Collected by',
 DrawnDate_Time:'Drawn Date&Time',
 Time_Lab:'Time of Sample received in Lab',
 Reffering_Doctor:'Reffering Doctor',
 Doctor_Name:'Doctor Name',

 //lab breadcrumb
 Lab_Amend_Report:'Lab Amend Report',
 Amend_Request:'Amend Request',
 Pathalogist_Worklist_Lab_supervisor:'Pathalogist Worklist Lab supervisor',
 Outsource_Pending:'Outsource Pending',
 Generate_stf:'Generate stf',
 Outsource_Completed:'Outsource Completed',
 Specimen_Inscan:'Specimen Inscan',
 LabWorklist_Abnormal_Result:'Lab Worklist Abnormal Result',
 Result_Entry_Review:'Result Entry Review',
 Reverse_Blood_Grouping:'Reverse Blood Grouping',
 Reverse_Blood_Grouping_Worklist:'Reverse Blood Grouping Worklist',
 Process:'Process',
 Lab_Refferal:'Lab Referral',
 Barcode:'Barcode',
 Lab_Amend:'Lab_Amend',
 //reverse blood breadcrumb
 Reverse_Blood_Grouping_Work_List:'Reverse Blood Grouping Work List',
 Reverse_Blood_Grouping_Status:'Reverse Blood Grouping Status'
},

Xray:{
  Radiology_Results:'Radiology Results',
},
call_center:{ 
//breadcrumb
Call_Centre:'Call Centre',
//call status
Answered:'Answered',
Busy:'Busy',
Not_Reachable:'Not Reachable',
Wrong_Number:'Wrong Number',
//sponsorType
Individual:'Individual',
Company:'Company',
Family:'Family',
//callstatus
Pending:'Pending Call logs',
Contacted:'Contacted',
Call_not_contacted:'Call not contacted',
Sponsor_Type:'Sponsor Type',
Sel_Sponsor_Type:'Select Sponsor Type',
Information_phStatus:'Information-Phone status',
Call_Count:'Call Count',
Letter_Print_Count:'Letter Print Count',
Visa_Referrence_Number:'Visa Referrence Number',
Date_of_Birth:'Date of Birth'

},
call_manager:{
  Reprint_First_Level_Approval:'Reprint First Level Approval',
  Submit_for_Approval:'Submit for Approval',
  External_Barcode_Generation:'External Barcode Generation'
},

feedback:{
    Feedback:'Feedback',
    collect:'Collect visitor’s experience at your counter',
    fb_btn:'Collect Feedback'
},

status_track:{
    Patient_Registration:'Patient Registration',
    Recently_visited:'(Recently visited)',
    Capture_Photo:'Capture Photo',
    Biometric_Recorded:'Biometric Recorded',
    Collect_Specimen:'Collect Specimen',
    Complete_Lab_Results:'Complete Lab Results',
    Complete_Radiology_Results:'Complete Radiology Results',
    Consultation_Process:'Consultation Process',
    Complete_Certificate:'Complete Certificate'
},

profile_menu:{
  Profile:'Profile',
  upload_image:'upload image',
  Change_Password:'Change Password',
  Language:'Language',
  Signature:'Signature',
  Logout:'Logout',
  Image:'Image',
  CLEAR:'CLEAR',
  Signature_required:'Signature is required',
  Old_password:'Old password',
  Enter_old_password:'Enter old password',
  New_password:'New password',
  Enter_new_password:'Enter new password',
  Confirm_password:'Confirm password',
  Confirm_password_err:'Confirm password not matched with new password',
  Enter_confirm_password:'Enter confirm password',
  Change_password:'Change password'//lower case
},

  dashboard_common:{
    Next:'Next',
    Skip:'Skip',
    Recall:'Recall',
    Pause:'Pause',
    Resume:'Resume',
    Assign_token:'Assign token',
    Break:'Break',
    Token_No:'Token No *',
    token_err1:'Please call the next token',
    token_err2:'Please enter valid token number',
    Verify_Token:'Verify Token',
    //biometric common
    Biometric_Verification:'Biometric Verification',
    Verification_of_Fingerprint:'Verification of Fingerprint',
    fp_placeholder:'Select Finger Index',
    Verify:'Verify',
    //AssignToken
    Assign_Token:'Assign Token',
    Sel_reason:'Select Reason',
    Sel_reason_err:'Please select any reason',
    //counter
    sel_counter:'Select Counter',
    sel_counter_err:'Please select counter and try again',
    Assign:'Assign',
    //Skip Token
    Skip_Token:'Skip Token',
    //counter selection
    Counter_Selection:'Counter Selection',
    Select:'Select',
    //Recall
    Recall_Token:'Recall Token',
    Waiting_for_Applicant:'Waiting for Applicant',
    Arrived:'Arrived',
    Welcome:'Hello'
  },

  common:{
    Country:'Country',
    Country_err:'Please select country',
    sel_country:'Select country',
    City:'City',
    City_not_available:'City is not available/Please select country',
    sel_city:'Select city',
    vn:'Visa Number',
    vn_placeholder:'Enter visa number',
    vn_err1:'Please enter visa number',
    vn_err2:'Please enter 12 digit valid number',
    From_Date:'From Date',
    To_Date:'To Date',
    Cancel:'Cancel',
    Search:'Search',
    no_record:' No records were found!',
    Download:'Download',
    Visa_No:'Visa No',
    Name:'Name',
    Occupation:'Occupation',
    Comments:'Comments',
    comments_placeholder:'Enter comments',
    Clear:'Clear',
    Save:'Save',
    Book_Appointment:'Book Appointment',
    Close:'Close',
    Reason:'Reason',
    SubReason:'Sub Reason',
    Select_reason:'Select reason',
    reason_err:'Please select reason',
    Yes:'Yes',
    No:'No',
    Date:'Date',
    End_Date:'End Date',
    please_wait:'Please wait...',
    Status:'Status',
    Select_status:'Select status',
    status_err:'Please select status',
    Action_Date_Time:'Action Date & Time',
    Collected:'Collected',
    Please_select_anyone:'Please select anyone',
    Please_enter_comments:'Please enter comments',
    No_Records_Found :'No Records Found!',
    vn_validate_err1:'Please enter visa application number',
    numeric_only:'Accept numeric values only',
    valid_visa_number:'Please enter valid visa application number',
    Patient_Number:'Patient Number',
    Today:'Today',
    Weeks:'Week',
    Month:'Month',
    Applicant_Name:'Applicant Name',
    Action:'Action',
    Reject:'Reject',
    Request:'Request',
    Accepted:'Accepted',
    Accept:'Accept',
    Test_Name:'Test Name',
    Priority:'Priority',
    Select_priority:'Select Priority',
    Retake:'Retake',
    Edit:'Edit',
    None:'None',
    Retest:'Retest',
    Complete:'Complete',
    Abnormal:'Abnormal',
    Normal:'Normal',
    List:'List',
    Rejected:'Rejected',
    Site_Name:'Site Name',
    Pending_to_scan:'Pending to Scan',
    Scanned:'Scanned',
    Container_Type:'Container Type',
    Specimen_Number:'Specimen Number',
    Specimen_number:'Specimen Number',
    Scan_Specimen_Number:'Scan Specimen Number',
    Specimen_Type:'Specimen Type',
    Container_Vacutainer:'Container/Vacutainer',
    Notes:'Notes',
    Enter_Notes:'Enter Notes',
    No_tests_found:'No tests were found!',
    Barcode_Reprint_Request:'Barcode Reprint Request',
    Retake_Reason:'Retake Reason',
    Pending:'Pending',
    Approved:'Approved',
    Processed_Date_Time:'Processed Date & Time',
    Processed_By:'Processed By',
    Please_enter_notes:'Please enter notes',
    Date_of_Birth:'Date of Birth',
    Sno:'Sno',
    Collection_Date:'Collection Date',
    Collection_By:'Collection By',
    Speciality:'Speciality',
    Confirmatory_Test:'Confirmatory Test',
    Additional_Lab_Test:'Additional Lab Test',
    Print_Count:'Print Count',
    RecommendedDate:'Recommended Next Visit Date',
    Result:'Result',
    Confirm:'Confirm',
    Detail:'Detail',
    Referral_Document:'Referral Document',
    Referral:'Referral',
    Create:'Create',
    Update:'Update',
    Select_Referral:'Select Referral',
    Select_Speciality:'Select Speciality',
    Select_ConfirmatoryTest:'Select Confirmatory Test',
    XRay_View:'X-Ray View',
    Select_XRayView:'Select X-Ray View',
    Please_select_refferal:'Please select issue referral',
    Lab_Test:'Lab Test',
    Select_LabTest:'Select Lab Test',
    Please_select_labtest:'Please select lab test',
    Select_LabRepeat:'Select Lab Repeat',
    Document_type:'Document Type',
    Next_action_date:'Next Action Date',
    Action_Date:'Action Date',
    field_required:'This field is required',
    No_Referrals_selected:'No Referrals were selected',
    Details:'Details',
    Results:'Results',
    Conclusion:'Conclusion',
    Validate:'Validate',
    DateTime:'Date & Time',
    Close_Status:'Close Status',
    WAITING_FOR_ACCEPT:'WAITING FOR ACCEPT',
    REJECTED:'REJECTED',
    CLOSED:'CLOSED',
    Close_referral:'Close referral',
    Uploaded_On:'Uploaded On',
    No_documents_found:'No documents were found',
    Approval:'Approval',
    Please_select_Accept_Reject:'Please select Accept or Reject',
    reason_for_reopen:'Enter reason for reopen',
    Result_Date:'Result Date',
    Result_Time:'Result Time',
    Resulted_Time:'Resulted Time',
    Lab_Test_Name:'Lab Test Name',
    Authorize_Date:'Authorize Date',
    Amendments:'Amendments',
    Select_reason_rejection:'Select reason for rejection',
    Done:'Done',
    Request_Date_Time:'Request Date Time',
    Department:'Department',
    User_Name:'User Name',
    Dashboard:'Dashboard',
    PRINT_RECEIPT:'PRINT RECEIPT',
    Alternative_Number:'Alternative Number',
    Submit:'Submit',
    Applicant_details:'Applicant Detail',
    Job_Position:'Job Position',
    Others:'Others',
    Assign_To:'Assign To',
    visa_type:'Visa Type',
    select_visa_type:'select visa type',
    visa_reference_number:'Visa Reference Number',
    speciality_upload:'Central Result Upload',
    Result_upload:'Information Result Upload',
    Additional:'Additional',
    Uploaded_by:'Uploaded by',
    rejected_reason:'Rejected reason',
    rejected_by:'Rejected by',
    Rejected_dt:'Rejected Date & Time',
    Uploaded_dt:'Uploaded Date & Time',
    //new line
    referral_type_reason:"Referral type reason",
    Referral_Refusal:"Referral Refusal",
    Print: "Print"
  },
  exit_management : {
    Poor : 'Poor',
    Average : 'Average',
    Good : 'Good',
    Excellent : 'Excellent',
    gro_role : 'HELP DESK',
    nurse_role : 'NURSE STATION',
    xray_role : 'X-RAY',
    gp_role : 'CONSULTATION',
    support_role : 'SECURITY/FLOOR',
    support_role1 : 'SUPPORT/FACILITY',
    support_role2 : 'SERVICE',
    scan_visa_number:'Scan Visa Number',
    enter_visa_number:'Enter Visa Number ',
    proceed:'Proceed',
    share_your_feedback_to_help_us_improve:'Share your feedback to help us improve',
    choose_language:'choose language',
    select_language:'select language',
    visa_validation:'Enter 12 digit visa Number',
    enter_vaild_visa:'Enter valid visa number',
    please_select_lang:'Please select language',
    thank_you:'Thank You',
    select_feedback:'Please select feedback',
    feedback_added_success:'Feedback saved successfully'

  }
  },
  ar: {
    tmsConnectionFailed: 'فشل الاتصال بخادم TMS',
    counterSignin: 'تم تسجيل الدخول إلى العداد بنجاح',
    ConfirmMessage: 'هل أنت متأكد من الحذف؟',
    logoutMessage: 'هل أنت متأكد من رغبتك في الخروج؟',
    unableDelete: 'يتعذر الحذف',
    unableSubmit: 'تعذر الإرسال',
    deleteMsg: 'تم الحذف بنجاح',
    invalidExcel : 'ملف اكسل غير صالح',
    processFirst : 'الرجاء تحديد العملية أولاً', 
    process : 'الرجاء تحديد العملية',
    userRole : 'الرجاء تحديد دور المستخدم',
    selectFingerindex : 'الرجاء تحديد السبابة وحاول مرة أخرى',
    unableConnect : 'تعذر توصيل جهاز Secugen',
    minFinger: 'يرجى تحميل ثلاث بصمات أصابع كحد أدنى',
    captureCode : 'رمز خطأ التقاط بصمات الأصابع: ',
    description : '.\وصف: ',
    matchFinger : 'تمت مطابقة تفاصيل بصمات الأصابع بنجاح',
    incorrectFinger : 'تفاصيل بصمة غير صحيحة',
    matchingFailed : 'فشل في مطابقة القالب',
    codeVerify : 'تم التحقق من رمزك بنجاح',
    codeSent : 'تم إرسال رمز التحقق إلى عنوان بريدك الإلكتروني المسجل',
    codeErr : 'خطأ في إرسال الرمز',
    contactAdmin : 'الرجاء الاتصال بالمسؤول الخاص بك',
    confirmMessage1:'جلستك على وشك الانتهاء, هل تحتاج إلى مزيد من الوقت؟',
    unableConnectSign : 'تعذر توصيل الجهاز',
    getSign : 'يرجى الحصول على التوقيع من مقدم الطلب',
    SelectDoc:'حدد نوع المستند للمستند رقم',
    SelectDocName:'أدخل اسم المستند للمستند رقم',
    uploadVaccinationDoc:'لم يتم اختيارك التطعيم بالترتيب الصحيح. لذا, تحتاج إلى تحميل المستند مقابل التطعيم, هل مازلت تريد الاستمرار بدون المستند؟',
    generation :'يرجى تحديد جيل عينة واحد على الأقل للمتابعة',
    collection :'يرجى تحديد مجموعة عينة واحدة على الأقل للمتابعة',
    skipToken : 'يرجى الاتصال بالرمز التالي ومحاولة التخطي',
    reassignToken : 'يرجى الاتصال بالرمز التالي ومحاولة التخصيص',
    recall : 'لا يمكن الوصول إلى زر التخطي أثناء عملية الاستدعاء',
    vaccineMsg:'هل تريد حفظ معلومات هذا اللقاح؟',
    noRecord:'لا يوجد سجلات',
    refusalContinue:'هل تريد متابعة عملية الرفض؟',
    refusalContinueGRO:'منذ ذلك الحين إذا لم يتم جمع التوقيع من مقدم الطلب, هل ترغب في مواصلة عملية الرفض؟',
    clinicalFit:'هل تريد الاستمرار في حفظ, يتم اختيار المريض على أنه لائق كليًا؟', 
    clinicalNotFit:'هل تريد المتابعة عند بدء حفظ, إحالة وسيطة',
    noReferral:'لم تبدأ إحالة لهذا مقدم الطلب',
    confirmReferralClose:'هل أنت متأكد من أنك تريد إغلاق هذه الإحالة؟',
    confirmReferralReopen:'هل أنت متأكد من أنك تريد إعادة فتح هذه الإحالة؟',
    uploadDoc:'يرجى تحميل الوثيقة',
    vaccinationDocMissing:'وثيقة التطعيم مفقودة',
    retestConfirm:'يرجى تأكيد إعادة الاختبار لـ ',



    gro:{
        // gro_dashboard
          mrg_msg:'مرحبًا', 
          vn_validate:'تحقق من صحة VN',
          pn_validate:'تحقق من صحة PN',
          vn_placeholder:'رقم طلب التأشيرة *',
          pn_placeholder:"رقم المريض *",
        // gro_stepLines
          step_line1:'الملف الشخصي للمريض',
          step_line2:'مكان الامر',
          step_line3:'التقاط الهوية',

        // gro_pp
          personal:'شخصي',
          title:'عنوان',
          title_err:'الرجاء تحديد العنوان',
          gender:'جنس',
          gender_err:'يرجى تحديد الجنس',
          nationality:'جنسية',
          nationality_err:'الرجاء تحديد الجنسية',
          marital_Sts:'الحالة الحالة الإجتماعية',
          f_Name:'الاسم الاول',
          s_Name:'الاسم الثاني',
          t_Name:'الاسم الثالث',
          fourth_Name:'الاسم الرابع',
          family_Name:'اسم العائلة',
          dob:'DOB',
          Age:'سن',
          Visa_Application:'نموذج الفيزا',
          Applicant_Believes_Pregnant:'مقدم الطلب يعتقد الحامل؟',
          // Applicant_Believes_Pregnant_err:'الرجاء تحديد أي شخص',
          Communication:'الاتصالات',
          Preferred_Communication:'الاتصال المفضل',
          Speak:'اللغة المفضلة للتحدث',
          Speak_err:'الرجاء تحديد اللغة المفضلة للتحدث',
          Read:'اللغة المفضلة للقراءة',
          Read_err:'الرجاء تحديد اللغة المفضلة للقراءة',
          // Preferred_loc:'المكان المفضل للإحالة ',
          Preferred_loc_err1:'حدد الدولة أولاً',
          Preferred_loc_err2:'الرجاء تحديد الموقع المفضل',
          Preferred_hosp:'المستشفى المفضل',
          Preferred_hosp_err1:'حدد الموقع المفضل أولاً',
          Preferred_hosp_err2:'الرجاء تحديد المستشفى المفضل ',
          SMS_Alert_No:'رقم التنبيه SMS',
          SMS_err1:'أدخل رقم تنبيه الرسائل القصيرة',
          SMS_err2:'الرجاء إدخال رقم صحيح',
          Off_Ph:'رقم الهاتف البديل',
          Off_Ph_err2:'الرجاء إدخال رقم هاتف بديل',
          Mob_Ph :'هاتف محمول',
          Mob_Ph_err2:'الرجاء إدخال الهاتف المحمول',
          Email:'البريد الإلكتروني',

          Enter_Address:'أدخل العنوان',
          Area:'منطقة',
          Enter_Area:'أدخل المنطقة',
          ZIP_Code:'الرمز البريدي',
          Enter_ZipCode:'أدخل الرمز البريدي',
          Province:'المحافظة',
          Enter_Province:'أدخل المقاطعة',


          Encounter:'يواجه .. ينجز',
          Visa_Category:'فئة التأشيرة',
          Visa_Category_err:'الرجاء تحديد فئة التأشيرة',
          Agency:'وكالة',
          Job_Position_err:'الرجاء تحديد الوظيفة',
          Driving:'هل الوظيفة قابلة للتطبيق على القيادة؟',
          Previous_resident:'مقيم سابق في قطر أم لا',
          Paid:'تدفع من قبل البعثة',  

          consent_abb:'اختصار الموافقة',
          pp_save:'احفظ واطبع',
          consent_form:'نموذج الموافقة المختصرة',
          sign_collect:'مجموعة توقيع مقدم الطلب',

          Refusal_Process:'عملية الرفض',
          Refusal_Status:'حالة الرفض',
          Refusal_Reason:'سبب الرفض',
          Applicant_Signature:'توقيع مقدم الطلب',

          Consent_Refusal:'رفض الموافقة',
          Please_select_reason:'الرجاء تحديد السبب',
          Please_enter_comments:'الرجاء إدخال التعليقات',

          Vaccination_Refusal:'رفض التطعيم',
          Referral_Refusal:'رفض الإحالة',
          Clear:'صافي',

          yes:'نعم',
          no:'رقم',
          maybe:'ربما',
          // pp_placeholders
          title_placeholder:'حدد العنوان',
          Gender_placeholder:'حدد نوع الجنس',
          Nationality_placeholder:'اختر الجنسية',
          Marital_placeholder:'حدد الحالة الاجتماعية',
          fn_placeholder:'أدخل الاسم الأول',
          sn_placeholder:'أدخل SecondName',
          tn_placeholder:'أدخل ThridName',
          fourthN_placeholder:'أدخل 4thName',
          fam_placeholder:'أدخل اسم العائلة',
          DOB_placeholder:'أدخل DOB',
          Age_placeholder:'أدخل العمر',
          VisaNumber_placeholder:'أدخل VisaNumber',
          select_placeholder:'يختار',
          country_placeholder:'حدد الدولة',
          Preferred_placeholder:'حدد الاتصال المفضل',
          speak_placeholder:'حدد اللغة المفضلة للتحدث',
          read_placeholder:'حدد اللغة المفضلة للقراءة',
          loc_placeholder:'حدد الموقع المفضل',
          hosp_placeholder:'حدد المستشفى المفضل',
          sms_placeholder:'رقم التنبيه عبر الرسائل القصيرة',
          off_placeholder:'رقم الهاتف البديل',
          mob_placeholder:'رقم الهاتف المحمول',
          email_placeholder:'أدخل البريد الإلكتروني',
          viseCat_placeholder:'حدد فئة التأشيرة',
          agency_placeholder:'حدد وكالة',
          jp_placeholder:'حدد الوظيفة',
          selectR_placeholder:'حدد السبب',
          cmt_placeholder:'أدخل التعليق',

        // gro_po
          Select_Service:'حدد الخدمة',
          Type:'يكتب',
          Priority:'أولوية',
          Amount:'مقدار',
          sub_btn:'المضي قدما في التحديد',


        // gro_capIdentity
          Capture:'يأسر',
          noCamera:'جهاز الكاميرا غير متوفر',
          Passport_Number:'رقم جواز السفر',
          Passport_Number_err:'الرجاء إدخال رقم جواز السفر',
          Issued_Date:'تاريخ الإصدار',
          Expiry_Date:'تاريخ انتهاء الصلاحية',
          expired_err:'يرجى تحديد تاريخ انتهاء الصلاحية',
          sel:'حدد الدولة',
          sel_err:'يرجى تحديد الدولة',
          Issued_At:'تم إصداره في',
          Issued_At_err:'الرجاء إدخال تاريخ الإصدار',
          add_doc:'أضف المستندات',
          doc_type:'نوع الوثيقة',
          doc_name:'اسم الملف',
          doc:'وثيقة',
          sel_doc:'حدد نوع المستند',
          vac_placeholder:'على سبيل المثال. شهادة تلقيح',
          add_doc1:'أضف وثيقة',
          SaveNext:'حفظ ثم التالي',
          Capture_Pic:'التقاط صور',
          Toggle:'تبديل',
          Switch_Camera:'تبديل الكاميرا',

        // gro_callCenter
          cc_heading:'سجل إحالة مركز الاتصال',
          fetch:'الجلب!',
          Referral_Type:'نوع الإحالة',
          ref_type:'حدد نوع الإحالة',
          Ageing:'شيخوخة',
          sel_Ageing:'حدد الشيخوخة',
          Call_Status:'حالة المكالمة',
          Select_call:'حدد حالة المكالمة',
          VisaAppNo:'رقم طلب التأشيرة',
          Referral_Date:'تاريخ الإحالة',
          Next_Action_Date:'تاريخ الإجراء التالي',
          Stage_of_Call:'مرحلة النداء',
          Actions:'أجراءات',
          Description:'وصف',
          Number_of_Successful_Calls:'عدد المكالمات الناجحة',
          Appointment_Date:'تاريخ الموعد',
          Overdue_Days:'الأيام المتأخرة',
          Number_of_calls:'عدد المكالمات',
          Last_Assigned_Agent:'آخر وكيل معين',
          Last_Call_Outcome:'نتيجة آخر مكالمة',
          Additional_Number:'رقم إضافي',
          Addtional_number:'رقم إضافي',
          Preferred_Speak:'اللغة المفضلة للتحدث',
          Preferred_Read:'اللغة المفضلة للقراءة',
          Preferred_Location_for_eferral:'الموقع المفضل للإحالة',
          Hospital_Name:'اسم المستشفى',
          Address:'تبوك',
          Attended:'حضرها',
          Busy:'مشغول',
          Not_Reachable:'لا يمكن الوصول إليه',
          Wrong_Number:'رقم غير صحيح',
          Call_Log_Updates:'تحديثات سجل المكالمات',
          Phone_Number:'رقم الهاتف',
          InformationCallLogs:'المعلومات - سجلات المكالمات',
          Appointment_Login:'موعد تسجيل الدخول',
          Pre_Lang:'اللغة المفضلة',
          placeholder_speak:'حدد اللغة المفضلة تحدث',
          speak_err:'الرجاء تحديد اللغة المفضلة',
          InboundOutbound:'واردة / صادرة',
          Inbound:'واردة',
          Outbound:'الصادرة',
          InboundOutbound_err:'الرجاء تحديد الوارد / الصادر',
          SMS_Sent:'تم إرسال الرسائل القصيرة',
          Email_Sent:'أرسل البريد الإلكتروني',
          sms_err:'يرجى التحقق من الرسائل القصيرة المرسلة',
          Call_Date:'تاريخ المكالمة',
          Call_Outcome:'نتيجة المكالمة',
          Assigned_Agent:'الوكيل المعين',
          External_Speciality:'التخصص الخارجي',
          Confirmatory:'التأكيد',
          XRay:'الأشعة السينية',

        // gro_specimen
          specimen_heading:'نموذج إحالة العينة',
          Labs:'مختبرات',
          Select_Lab:'حدد معمل',
          SpecimenID:'معرّف طاقم عمل دفعة العينة',
          Location:'موقع',
          Generated_Date:'تاريخ الإنشاء',
          Collected_Date:'تاريخ جمعها',
          serialNo:'الرقم التسلسلي.',
          ExtID:'معرف العينة التحويلية',
          Container:'حاوية / فاكوتينير',
          CollectedOn:'جمعت في',
          Container_:'وعاء',

        // gro_refusalToContinue
           RefuseToContinue:'رفض متابعة التقرير',
           Date_Time:'التاريخ و الوقت',
           Call_Centre_Informed:'علم مركز الاتصال',
           MOI_Informed:'وزارة الداخلية على علم',

        // exit_process
          Exit_Check_Process_Report:'إنهاء تقرير عملية التحقق',
          Ext_Scan_Date_Time:'تاريخ الخروج من المسح الضوئي',
          Final_Status:'الوضع النهائي',
          GRO_Process:'عملية GRO',
          Nurse_Process:'عملية الممرضة',
          XRay_Process:'عملية الأشعة السينية',
          GP_Process:'عملية GP',
          Action_Required:'الإجراء مطلوب',
          

          // GRO Referral print letter
          GRO_Referral_Call_Log:'سجل مكالمات إحالة GRO',
          Print_Referral_Letter:'طباعة خطاب الإحالة',
          Upload_Referral_Document:'تحميل وثيقة الإحالة',
          Print_Receipt:'اطبع الايصال',
          Refused_continue:'رفض الاستمرار',
          Please_select_refusal_reason:'الرجاء تحديد سبب الرفض',
          Please_select_signature:'الرجاء تحديد التوقيع',

          //upload document
          document_upload:'يُسمح بتحميل المستند فقط للإحالات (نوع المستند) التي تمت طباعة خطاب الإحالة من أجلها',
          Uploaded_Referral_Document:'وثيقة الإحالة التي تم تحميلها',
          Please_enter_document_name:'الرجاء إدخال اسم الوثيقة',
          Upload_Document:'تحميل المستند',
          Browse:'تصفح',

          //gro breadcrumb
          Print_Referral_Document:'طباعة مستند الإحالة',
          Upload_Referral:'تحميل الإحالة',
          Exit_Process_Report:'تقرير عملية الخروج',
          Refusal_Continue:'استمرار الرفض',
          Specimen_Form:'نموذج العينة',
          Call_Center_Referral:'إحالة مركز الاتصال',
          VN_Registration:'تسجيل VN',
          Referral_Call:'دعوة الإحالة',
          Staff_Dashboard:'GRO Staff Dashboard',

    },

      nurse:{
        Record_Vitals:'سجل العناصر الحيوية',
        Specimen_Generation:'توليد العينة',
        Specimen_Collection:'جمع العينات',
        Vaccination:'تلقيح',
        //Record vitals
        Body_Mass_Index:'مؤشر كتلة الجسم',
        Height:'ارتفاع',
        height_placeholder:'أدخل الارتفاع',
        height_err1:'الرجاء إدخال الارتفاع',
        height_err2:'الحد الأقصى المسموح به 3 أرقام',
        height_err3:'الرجاء إدخال الارتفاع الصحيح الخاص بك',
        Weight:'وزن',
        weight_placeholder:'أدخل الوزن',
        weight_err1:'الرجاء إدخال الوزن',
        weight_err2:'الحد الأقصى المسموح به 3 أرقام',
        weight_err3:'الرجاء إدخال وزنك الصحيح',
        BMI:'مؤشر كتلة الجسم',
        bmi_placeholder:'أدخل مؤشر كتلة الجسم الخاص بك',
        Out_of_range:'خارج النطاق',
        Vision:'رؤية',
        Right_Vision:'الرؤية الصحيحة',
        r_vision_err:'الرجاء تحديد الرؤية الصحيحة',
        Left_Vision:'الرؤية اليسرى',
        l_vision_err:'الرجاء تحديد الرؤية اليسرى',
        Color_Vision:'رؤية الألوان',
        Poor:'فقير',
        ColorV_err:'تحقق من أي رؤية لونية واحدة',
        Color_Plates:'لوحات ملونة',
        Color_Plate:'لوحة الألوان',
        Color_Plate_err:'يرجى اختيار لوحة الألوان',
        Select_color_plate:'حدد لوحة الألوان',
        bp:'ضغط الدم',
        sp:'الضغط الانقباضي',
        sp_err1:'الرجاء إدخال الضغط الانقباضي',
        height_err:'الرجاء إدخال الارتفاع الصحيح',
        weight_err:'الرجاء إدخال الوزن الصحيح',
        Select_Right_Vision:'حدد الرؤية الصحيحة',
        Select_Left_Vision:'حدد الرؤية اليسرى',

        dp:'الضغط الانبساطي',
        dp_err1:'الرجاء إدخال الضغط الانبساطي',
        Systolic:'الانقباضي',
        Diastolic:'الانبساطي',

        Order_ID:'رقم التعريف الخاص بالطلب',
       //Generate Specimen
        Generate_Specimen:'لتوليد عينة',
        Show_barcode:'اظهر الشفرة',
        collection:'من Vacutainer إلى الكاميرا بعد التجميع',
        Immediately_Place:'مكان على الفور',
        codeTocamera:'Vacutainer فقط في صندوق جمع العينات يظهر الرمز الشريطي للكاميرا',
        takeSampel:'لا تأخذ عينة في فاكوتينير غير مشفر وعينة باستخدام حقنة وإبرة',

        Generate_Specimen1:'توليد عينة',
        Container:'وعاء',
        Action_By:'عمل بواسطة',
        Barcode_Print_Request:'طلب طباعة الباركود',
        Collected:'جمعت',

      // vaccine
        Vaccine_Given:'لقاح أعطته ممرضة؟',
        Select_option:'حدد اختيارا',
        Select_option_err:'الرجاء تحديد حالة اللقاح',
        batch_no:'أدخل رقم الدفعة',
        batch_no_err1:'الرجاء إدخال رقم الدفعة',
        batch_no_err2:'الرجاء إدخال الحد الأدنى لرقم الدفعة المكون من 12 رقمًا',
        batch_no_err3:'الرجاء إدخال رقم دفعة صالح',
        Document:'وثيقة',
        Generate_Voucher:'إنشاء القسيمة',
        pls_wait:'أرجو الإنتظار...',

      // sample_out
        Sample_outgoing:'عينة المنتهية ولايته',
        Priority:'أولوية',
        Sel_priority:'حدد الأولوية',
        LabGRO:'فني مختبر ومعلومات GRO',
        Lab_Tech_Name:'اسم المعمل الفني',
        Select_Lab_Tech_name:'حدد اسم Lab Tech',
        Please_select_lab_technician:'الرجاء تحديد فني مختبر',
        GRO_Name:'اسم GRO',
        Select_GRO_name:'حدد اسم GRO',
        Please_select_GRO:'الرجاء تحديد GRO',
      // barcode_reprint
        Barcode_Printing_Request:'طلب طباعة الباركود',
        Patient_Number:'رقم المريض',
        Name:'اسم',
        Print:'مطبعة',

        // nurse breadcrumb
        Barcode_reprint:'طبع الباركود',
        Nursing_Process:'عملية التمريض'
    },

    gp:{
      // Nursing_outcome
        Nursing_Outcome:'نتائج التمريض',
        Consultation:'التشاور',
        VITAL_INFORMATION:'معلومات حيوية',
        VACCINE_INFORMATION:'معلومات اللقاح',
        batch_no:'أدخل رقم الدفعة',
        Vaccine_Document:'وثيقة اللقاح',
        Captured_Date:'تاريخ الالتقاط',
        Captured_By:'التقطت بواسطه',
       //consultation
        Preset:'المعد مسبقا',
        Select_preset:'حدد الإعداد المسبق',
        Normal:'طبيعي',
        Abnormal:'غير طبيعي',
        Please_select_preset:'الرجاء تحديد الإعداد المسبق',
        Cardiovascular_System:'نظام القلب والأوعية الدموية',
        Enter_Cardiovascular_System:'أدخل نظام القلب والأوعية الدموية',
        Cardiovascular_System_is_required:'مطلوب نظام القلب والأوعية الدموية',
        add:'يضيف',
        Deformity:'تشوه',
        Deformity_System_is_required:'مطلوب نظام تشوه',
        Respiratory_System:'الجهاز التنفسي',
        Respiratory_System_is_required:'مطلوب الجهاز التنفسي',
        Deformities:'تشوهات',
        Deformities_is_required:'التشوهات مطلوبة',
        Gastro_Intestinal_System:'الجهاز الهضمي',
        Gastro_required:'مطلوب الجهاز الهضمي',
        Skin:'جلد',
        Skin_required:'الجلد مطلوب',
        Eye:'عين',
        Eye_required:'العين مطلوب',
        Venereal_Diseases:'الأمراض التناسلية',
        Enter_Veneral_Diseases:'أدخل الأمراض العامة',
        Veneral_Diseases_required:'مطلوب أمراض عامة',
        Ear:'أذن',
        Ear_required:'مطلوب الأذن',
        CNS:'الجهاز العصبي المركزي',
        Enter_CNS:'أدخل CNS',
        CNS_required:'مطلوب CNS',
        Hernia:'فتق',
        Enter_Hernia:'أدخل الفتق',
        Hernia_required:'الفتق مطلوب',
        Psychiatry:'الطب النفسي',
        Enter_Psychiatry:'أدخل الطب النفسي',
        Psychiatry_required:'مطلوب الطب النفسي',
        Varicose_Veins:'توسع الأوردة',
        Enter_Varicose_Veins:'أدخل الدوالي',
        Varicose_Veins_required:'مطلوب توسع الأوردة',
        Other_Referral:'إحالة أخرى - لأي تاريخ طبي يرجى رفع الإحالة هنا',
        Enter_Referral_Remark:'أدخل ملاحظة الإحالة',
        Other_required:'مطلوب إحالة أخرى',
        Extremities:'الأطراف',
        Enter_Extremities:'أدخل الأطراف',
        Extremities_required:'الأطراف مطلوبة',
        Random_sample:'عينة عشوائية',
        Enter_Random_sample:'أدخل عينة عشوائية',
        Random_sample_required:'مطلوب عينة عشوائية',
        Clinical_Fit:'اللياقة السريرية',
        Medical_History:'تاريخ طبى',
        Previous_Illness:'المرض السابق',
        Please_enter_previous_illness:'الرجاء إدخال المرض السابق',
        your_meals:'هل تناولت وجباتك في آخر 10 ساعات؟',
        Psychiatric_or_Neurological_Disorder:'اضطراب نفسي أو عصبي',
        Please_enter_disorder:'الرجاء إدخال الاضطراب النفسي أو العصبي',
        Allergies:'الحساسية',
        Drugs:'المخدرات',
        drugs_allergies:'يرجى ذكر حساسية الأدوية',
        Dust:'تراب',
        dust_allergies:'يرجى ذكر حساسية الغبار',
        Food:'غذاء',
        food_allergies:'يرجى ذكر الحساسية الغذائية',
        Fumes:'أبخرة',
        fumes_allergies:'يرجى ذكر حساسية الأبخرة',
        other_allergies:'يرجى ذكر أي أنواع أخرى من الحساسية',
        Previous_Referrals:'الإحالات السابقة',
        Speciality:'تخصص',
        Action_Date:'تاريخ العمل',
        Clinical_notes:'ملاحظات سريرية',
        Referral_Letter:'خطاب الإحالة',
        View:'رأي',
        Edit:'يحرر',
        Delete:'حذف',
        Intermediate_Referral:'إحالة وسيطة',
        select_speciality:'الرجاء تحديد التخصص',
        select_action_date:'الرجاء تحديد تاريخ الإجراء',
        select_future_dates:'الرجاء تحديد التواريخ المستقبلية',
        Clinical_Notes:'ملاحظات سريرية',
        Enter_Notes:'أدخل الملاحظات',
        enter_clinical_notes:'الرجاء إدخال الملاحظات السريرية',
        Referrals_Created:'تم إنشاء الإحالات',
        Total_Referrals_Created:'إجمالي الإحالات التي تم إنشاؤها',
        Referral_No:'رقم الإحالة',
        No_referrals:'لم يتم إنشاء إحالات',
        Go_To_Feedback:'انتقل إلى التعليقات',
        Vitals_History:'التاريخ الحيوي',
        //other-referral
        Other_Document_Name:'اسم المستند الآخر',
        Other_Document_Type:'نوع مستند آخر',
        Created_On:'تم إنشاؤها على',
        //physician worklist
        Physician_Worklist:'قائمة عمل الطبيب',
        Ready_to_Consult:'جاهز للتشاور',
        Referral_Reported:'يتم الإبلاغ عن الإحالة',
        Registered_Date:'تاريخ التسجيل',
        Previous_Assign_User:'المستخدم المعين السابق',
        Assign_User:'مستخدم معين',
        Physician:'الطبيب المعالج',
        //annual physical examination
        Annual_Physical_Examination:'الفحص البدني السنوي',
        Ecg_Worklist:'قائمة عمل تخطيط القلب',
        Usg_Worklist:'قائمة عمل USG',
        //critical notification
        Critical_Notification:'الإخطار الحرج',
        SampleType_TestName:'نوع العينة / اسم الاختبار',
        Panic_Value:'قيمة الذعر',
        //certiticate
        Vitals:'العناصر الحيوية',
        VITALS:'العناصر الحيوية',
        WARNING:'تحذير',
        FIT:'لائق بدنيا',
        AWAITING:'في انتظار',
        Lab:'مختبر',
        LAB:'مختبر',
        Radiology:'الأشعة',
        RADIOLOGY:'الأشعة',
        CONSULTATION:'استشارة',
        Total_Referrals_issued:'إجمالي الإحالات الصادرة',
        Referrals_Closed:'الإحالات مغلقة',
        Referrals_Open:'الإحالات مفتوحة',
        Referral_Ready_Review:'الإحالة جاهزة للمراجعة',
        View_Referral_Document:'عرض مستند الإحالة',
        Medical_Report:'تقرير طبي',
        Owner:'صاحب',
        Issue_Referral:'قضية الإحالة',
        Lab_Report:'تقرير معمل',
        CREATE_REFERRAL:'إنشاء الإحالة',
        Physician_Name:'اسم الطبيب',
        Previous_Brief_History:'التاريخ الموجز السابق',
        Save_Intermediate:'هل تريد الاستمرار في حفظ, متوسط',
        Referral_initiated:'هل بدأت الإحالة؟',
        InformationLab:'المعلومات - مختبر',
        Lab_Confirmatory:'تأكيد المعمل',
        Additional_XRay:'أشعة سينية إضافية',
        ABNORMALITES_CAPTURED:'تم أسر الشذوذ',
        Vital_Information:'معلومات حيوية',
        Consultation_Information:'معلومات الاستشارة',
        Lab_Information:'معلومات المعمل',
        XRay_Information:'معلومات الأشعة السينية',
        //referral document
        No_referral_documents_found:'لم يتم العثور على وثائق إحالة',
        Referral_Consultation_Document:'وثيقة استشارة الإحالة',
        Referral_Reopen:'إعادة فتح الإحالة',
        BP:'BP',
        Add_Vitals:'أضف العناصر الحيوية',
        //status tab
        Other_Document:'وثيقة أخرى',
        //gp breadcrumb
        NurseOutcome:'ممرضة النتيجة',
        Certificate:'شهادة',
        Create_Referral:'إنشاء الإحالة',
        // Consultation_Process:'Consultation Process',
        Doctor_Referral_Process:'عملية إحالة الطبيب',
        Referral_Report:'تقرير الإحالة'
      },

    lab:{
      //speciemn inscan
      Specimen_Inscan_Process:'عملية Inscan العينة',
      Counter:'يعداد',
      Select_counter:'حدد العداد',
      Lab_ID:'معرف المعمل',
      Collected_DateTime:'تم جمع التاريخ والوقت',
      Collected_By:'جمع بواسطة',
      Outgoing_DateTime:'التاريخ والوقت الصادر',
      Outgoing_By:'الصادرة عن طريق',
      Accepted_RejectedOn:'تم القبول / الرفض في',
      Accepted_RejectedBy:'مقبول / مرفوض من قبل',
      Lab_Tests_Specimen:'الاختبارات المعملية للعينة',
      Reason_reject_specimen:'سبب رفض العينة',

      //Lab Worklist
      Lab_Worklist:'قائمة عمل المعمل',
      Accepted_By:'قبلت من طرف',
      Interface_Date:'تاريخ الواجهة',
      Result_Entry:'نتيجة الإدخال',
      Spec_No:'Spec. No',
      Analyzer_Name:'اسم المحلل',
      Result:'نتيجة',
      Cut_Off:'قطع',
      Units:'الوحدات',
      Normal_Range:'المعدل الطبيعي',
      Is_Normal:'طبيعي',
      First_Review:'أول مراجعة',
      Submit_First_Review:'إرسال للمراجعة الأولى',
      Lab_Tests_Details:'تفاصيل الاختبارات المعملية',
      Run_Code:'قم بتشغيل الكود',
      Result_Units:'وحدات النتائج',
      Resulted_DateTime:'التاريخ والوقت الناتج',
      //rejected worklist
      Rejected_Worklist:'قائمة العمل المرفوضة',
      //lab senior-lab review
      Submit_for_Review:'تقديم للمراجعة',
      //lab director (lab amend report) 
      Amend_Report:'تعديل التقرير',
      Request_Date_Time:'تاريخ الطلب الوقت',
      Request_By:'طلب بواسطة',
      Request_Reason:'سبب الطلب',
      Information:'معلومة',
      mapBarcode: 'خريطة الباركود',

     //lab supervisor(pathalogist)
     Pathalogist_Worklist:'قائمة عمل Pathalogist',
     Authorize_All:'تفويض الكل',
     Submit_for_Authorizer:'إرسال للمفوض',
     Amend_Reason:'تعديل السبب',
     Select_qualitative_type:'حدد النوع النوعي',

     //trf
     Test_Requisition_Form:'استمارة طلب الاختبار',
     Print_TRF:'طباعة TRF',
     VNR_NO:'رقم VNR',
     Specimen_Information:'معلومات العينة',
     Sample_Collectedby:'تم جمع العينة بواسطة',
     DrawnDate_Time:'وقت التاريخ المرسوم',
     Time_Lab:'وقت استلام العينة في المختبر',
     Reffering_Doctor:'إحالة طبيب',
     Doctor_Name:'اسم الطبيب',

     //lab breadcrumb
     Lab_Amend_Report:'تقرير تعديل المعمل',
     Amend_Request:'تعديل الطلب',
     Pathalogist_Worklist_Lab_supervisor:'مشرف مختبر Pathalogist Worklist',
     Outsource_Pending:'الاستعانة بمصادر خارجية معلقة',
     Generate_stf:'توليد stf',
     Outsource_Completed:'اكتمل الاستعانة بمصادر خارجية',
     Specimen_Inscan:'عينة Inscan',
     LabWorklist_Abnormal_Result:'نتيجة غير طبيعية لقائمة عمل المختبر',
     Result_Entry_Review:'نتيجة مراجعة الإدخال',
     Reverse_Blood_Grouping:'تجميع الدم العكسي',
     Reverse_Blood_Grouping_Worklist:'قائمة العمل العكسي لفصائل الدم',
     Process:'معالجة',
     Lab_Refferal:'إحالة معمل',
     Barcode:'الرمز الشريطي',
     Lab_Amend:'Lab_Amend',
     //reverse blood breadcrumb
     Reverse_Blood_Grouping_Work_List:'قائمة العمل العكسي لفصائل الدم',
     Reverse_Blood_Grouping_Status:'عكس حالة تصنيف الدم'
    },

    Xray:{
      Radiology_Results:'نتائج الأشعة',
    },
    call_center:{ 
    //breadcrumb
    Call_Centre:'مركز الاتصالات',
    //call status
    Answered:'أجاب',
    Busy:'مشغول',
    Not_Reachable:'لا يمكن الوصول إليه',
    Wrong_Number:'رقم غير صحيح',
    //sponsorType
    Individual:'الفرد',
    Company:'شركة',
    Family:'عائلة',
    //callstatus
    Pending:'سجلات المكالمات المعلقة',
    Contacted:'تم الاتصال',
    Call_not_contacted:'لم يتم الاتصال بالمكالمة',
    Sponsor_Type:'نوع الكفيل',
    Sel_Sponsor_Type:'اختر نوع الراعي',
    Information_phStatus:'معلومات الهاتف حالة',
    Call_Count:'عدد المكالمات',
    Letter_Print_Count:'عدد طباعة الرسالة',
    Visa_Referrence_Number:'رقم التأشيرة المرجعي',
    Date_of_Birth:'تاريخ الولادة'

    },
    call_manager:{
      Reprint_First_Level_Approval:'إعادة طباعة اعتماد المستوى الأول',
      Submit_for_Approval:'تقدم للحصول على موافقة',
      External_Barcode_Generation:'توليد الباركود الخارجي'
    },

  feedback:{
      Feedback:'استجابة',
      collect:'اجمع تجارب الزوار عند المنضدة الخاصة بك',
      fb_btn:'اجمع التعليقات'
  },

  status_track:{
      Patient_Registration:'تسجيل المريض',
      Recently_visited:'(تمت زيارتها مؤخرًا)',
      Capture_Photo:'التقاط الصور',
      Biometric_Recorded:'تم تسجيل القياسات الحيوية',
      Collect_Specimen:'جمع العينة',
      Complete_Lab_Results:'نتائج المختبر كاملة',
      Complete_Radiology_Results:'نتائج الأشعة الكاملة',
      Consultation_Process:'عملية التشاور',
      Complete_Certificate:'شهادة كاملة'
  },

  profile_menu:{
    Profile:'الملف الشخصي',
    upload_image:'تحميل الصور',
    Change_Password:'غير كلمة السر',
    Language:'لغة',
    Signature:'التوقيع',
    Logout:'تسجيل خروج',
    Image:'صورة',
    CLEAR:'صافي',
    Signature_required:'التوقيع مطلوب',
    Old_password:'كلمة المرور القديمة',
    Enter_old_password:'أدخل كلمة المرور القديمة',
    New_password:'كلمة السر الجديدة',
    Enter_new_password:'أدخل كلمة مرور جديدة',
    Confirm_password:'تأكيد كلمة المرور',
    Confirm_password_err:'تأكيد كلمة المرور غير متطابقة مع كلمة المرور الجديدة',
    Enter_confirm_password:'أدخل تأكيد كلمة المرور',
    Change_password:'غير كلمة السر'//lower case
  },

  dashboard_common:{
    Next:'التالي',
    Skip:'يتخطى',
    Recall:'اعد الاتصال',
    Pause:'يوقف',
    Resume:'سيرة ذاتية',
    Assign_token:'تعيين رمز',
    Break:'فترة راحة',
    Token_No:'رمز لا *',
    token_err1:'يرجى الاتصال بالرمز التالي',
    token_err2:'الرجاء إدخال رقم مميز صالح',
    Verify_Token:'تحقق من الرمز',
    //biometric common
    Biometric_Verification:'التحقق البيومتري',
    Verification_of_Fingerprint:'التحقق من البصمة',
    fp_placeholder:'حدد مؤشر الإصبع',
    Verify:'يؤكد',
    //AssignToken
    Assign_Token:'تعيين رمز',
    Sel_reason:'حدد السبب',
    Sel_reason_err:'الرجاء تحديد أي سبب',
    //counter
    sel_counter:'حدد العداد',
    sel_counter_err:'الرجاء تحديد العداد والمحاولة مرة أخرى',
    Assign:'تعيين',
    //Skip Token
    Skip_Token:'رمز التخطي',
    //counter selection
    Counter_Selection:'اختيار العداد',
    Select:'يختار',
    //Recall
    Recall_Token:'أذكر الرمز',
    Waiting_for_Applicant:'في انتظار مقدم الطلب',
    Arrived:'وصل',
    Welcome:'مرحبًا'
  },

  common:{
    Country:'دولة',
    Country_err:'الرجاء تحديد الدولة',
    sel_country:'حدد الدولة',
    City:'مدينة',
    City_not_available:'المدينة غير متوفرة / الرجاء تحديد الدولة',
    sel_city:'اختر مدينة',
    vn:'رقم الفيزا',
    vn_placeholder:'أدخل رقم التأشيرة',
    vn_err1:'الرجاء إدخال رقم التأشيرة',
    vn_err2:'الرجاء إدخال رقم صالح مكون من 12 رقمًا',
    From_Date:'من التاريخ',
    To_Date:'حتي اليوم',
    Cancel:'يلغي',
    Search:'يبحث',
    no_record:' لم يتم العثور على سجلات!',
    Download:'تحميل',
    Visa_No:'رقم التأشيرة',
    Name:'اسم',
    Occupation:'إشغال',
    Comments:'تعليقات',
    comments_placeholder:'أدخل التعليقات',
    Clear:'صافي',
    Save:'يحفظ',
    Book_Appointment:'موعد الكتاب',
    Close:'قريب',
    Reason:'سبب',
    Select_reason:'حدد السبب',
    reason_err:'الرجاء تحديد السبب',
    Yes:'نعم',
    No:'رقم',
    Date:'تاريخ',
    End_Date:'تاريخ الانتهاء',
    please_wait:'أرجو الإنتظار...',
    Status:'حالة',
    Select_status:'حدد الحالة',
    status_err:'الرجاء تحديد الحالة',
    Action_Date_Time:'وقت تاريخ العمل',
    Collected:'جمعت',
    Please_select_anyone:'الرجاء تحديد أي شخص',
    Please_enter_comments:'الرجاء إدخال التعليقات',
    No_Records_Found :'لا توجد سجلات!',
    vn_validate_err1:'الرجاء إدخال رقم طلب التأشيرة',
    numeric_only:'اقبل القيم الرقمية فقط',
    valid_visa_number:'الرجاء إدخال رقم طلب تأشيرة صالح',
    Patient_Number:'رقم المريض',
    Today:'اليوم',
    Weeks:'أسبوع',
    Month:'شهر',
    Applicant_Name:'اسم التطبيق',
    Action:'عمل',
    Reject:'رفض',
    Request:'طلب',
    Accepted:'وافقت',
    Accept:'قبول',
    Test_Name:'اسم الاختبار',
    Priority:'أولوية',
    Select_priority:'حدد الأولوية',
    Retake:'إعادة',
    Edit:'يحرر',
    None:'لا أحد',
    Retest:'إعادة الاختبار',
    Complete:'مكتمل',
    Abnormal:'غير طبيعي',
    Normal:'طبيعي',
    List:'قائمة',
    Rejected:'مرفوض',
    Site_Name:'اسم الموقع',
    Pending_to_scan:'في انتظار الفحص',
    Scanned:'الممسوحة ضوئيا',
    Container_Type:'نوع الحاوية',
    Specimen_Number:'رقم العينة',
    Specimen_number:'رقم العينة',
    Scan_Specimen_Number:'رقم عينة المسح الضوئي',
    Specimen_Type:'نوع العينة',
    Container_Vacutainer:'حاوية / فاكوتينير',
    Notes:'ملحوظات',
    Enter_Notes:'أدخل الملاحظات',
    No_tests_found:'لم يتم العثور على اختبارات!',
    Barcode_Reprint_Request:'طلب إعادة طباعة الباركود',
    Retake_Reason:'استعادة السبب',
    Pending:'قيد الانتظار',
    Approved:'وافق',
    Processed_Date_Time:'تاريخ المعالجة الوقت',
    Processe_By:'معالجتها بواسطة',
    Please_enter_notes:'الرجاء إدخال الملاحظات',
    Date_of_Birth:'تاريخ الولادة',
    Sno:'SNO',
    Collection_Date:'تاريخ التحصيل',
    Collection_By:'تجميع بواسطة',
    Speciality:'تخصص',
    Confirmatory_Test:'اختبار تأكيدي',
    Additional_Lab_Test:'اختبار معملي إضافي',
    Print_Count:'عدد الطباعة',
    RecommendedDate:'تاريخ الزيارة التالية الموصى به',
    Result:'نتيجة',
    Confirm:'يتأكد',
    Detail:'التفاصيل',
    Referral_Document:'وثيقة الإحالة',
    Referral:'الإحالة',
    Create:'خلق',
    Update:'تحديث',
    Select_Referral:'حدد الإحالة',
    Select_Speciality:'حدد التخصص',
    Select_ConfirmatoryTest:'حدد الاختبار التأكيدي',
    XRay_View:'عرض الأشعة السينية',
    Select_XRayView:'حدد X-Ray View',
    Please_select_refferal:'الرجاء تحديد قضية الإحالة',
    Lab_Test:'اختبار معمل',
    Select_LabTest:'حدد اختبار معمل',
    Please_select_labtest:'الرجاء تحديد اختبار معمل',
    Select_LabRepeat:'حدد Lab Repeat',
    Document_type:'نوع الوثيقة',
    Next_action_date:'تاريخ الإجراء التاليe',
    Action_Date:'تاريخ العمل',
    field_required:'هذه الخانة مطلوبه',
    No_Referrals_selected:'لم يتم اختيار أي إحالات',
    Details:'تفاصيل',
    Results:'نتائج',
    Conclusion:'استنتاج',
    Validate:'تحقق',
    DateTime:'التاريخ والوقت',
    Close_Status:'إغلاق الحالة',
    WAITING_FOR_ACCEPT:'في انتظار القبول',
    REJECTED:'مرفوض',
    CLOSED:'مغلق',
    Close_referral:'إغلاق الإحالة',
    Uploaded_On:'تم الرفع في',
    No_documents_found:'لم يتم العثور على وثائق',
    Approval:'موافقة',
    Please_select_Accept_Reject:'الرجاء تحديد قبول أو رفض',
    reason_for_reopen:'Enter reason for reopen',
    Result_Date:'تاريخ النتيجة',
    Result_Time:'وقت النتيجة',
    Resulted_Time:'الوقت الناتج',
    Lab_Test_Name:'اسم الاختبار المعملي',
    Authorize_Date:'تاريخ المصادقة',
    Amendments:'تعديلات',
    Select_reason_rejection:'حدد سبب الرفض',
    Done:'فعله',
    Request_Date_Time:'تاريخ الطلب الوقت',
    Department:'قسم',
    User_Name:'اسم االمستخدم',
    Dashboard:'لوحة القيادة',
    PRINT_RECEIPT:'اطبع الايصال',
    Alternative_Number:'عدد البديل',
    Submit:'يُقدِّم',
    Applicant_details:'تفاصيل مقدم الطلب',
    Job_Position:'وظيفه',
    Others:'آحرون',
    Assign_To:'يسند إلى',
    visa_type:'نوع الفيزا',
    select_visa_type:'حدد نوع التأشيرة',
    visa_reference_number:'الرقم المرجعي للتأشيرة',
    speciality_upload:'تحميل نتيجة مركزية',
    Result_upload:'تحميل نتيجة المعلومات',
    Additional:'إضافي',
    Uploaded_by:'تم الرفع بواسطة',
    rejected_reason:'سبب مرفوض',
    rejected_by:'مرفوض من طرف',
    Rejected_dt:'التاريخ والوقت المرفوضين',
    Uploaded_dt:'تاريخ التحميل والوقت'
  },
  exit_management :{
    Poor : 'فقير',
    Average : 'متوسط',
    Good : 'جيد',
    Excellent : 'ممتاز',
    gro_role : 'مكتب المساعدة',
    nurse_role : 'محطة التمريض',
    xray_role : 'أشعة سينية',
    gp_role : 'استشارة',
    support_role : 'أمان / الطابق',
    support_role1 : 'الدعم / المرفق',
    support_role2 : 'خدمة',
    scan_visa_number:'مسح رقم التأشيرة',
    enter_visa_number:'أدخل رقم التأشيرة ',
    proceed:'يتابع',
    share_your_feedback_to_help_us_improve:'شارك بتعليقاتك لمساعدتنا على التحسن',
    choose_language:'اختر اللغة',
    select_language:'اختار اللغة',
    visa_validation:'أدخل رقم التأشيرة المكون من 12 رقمًا',
    enter_vaild_visa:'أدخل رقم التأشيرة الصحيح',
    please_select_lang:'الرجاء اختيار اللغة',
    thank_you:'شكرًا لك',
    select_feedback:'الرجاء تحديد ردود الفعل',
    feedback_added_success:'تم حفظ التعليقات بنجاح'
    
  },
},
ta:{
  common:{
    Submit : 'சமர்ப்பிக்க'
  },
  exit_management :{
    Poor : 'நன்றாக இல்லை ',
    Average : 'சராசரி',
    Good : 'நல்ல',
    Excellent : 'சிறந்த',
    gro_role : 'ஹெல்ப் டெஸ்க்',
    nurse_role : 'செவிலியர் நிலையம்',
    xray_role : 'எக்ஸ்-ரே',
    gp_role : 'ஆலோசனை',
    support_role : 'பாதுகாப்பு/தரை',
    support_role1 : 'ஆதரவு/வசதி',
    support_role2 : 'சேவை',
    scan_visa_number:'விசா எண்ணை ஸ்கேன் செய்யவும்',
    enter_visa_number:'விசா எண்ணை உள்ளிடவும் ',
    proceed:'தொடர',
    share_your_feedback_to_help_us_improve:'மேம்படுத்த எங்களுக்கு உதவ உங்கள் கருத்தைப் பகிரவும்',
    choose_language:'மொழியை தேர்வு செய்யவும்',
    select_language:'மொழியை தேர்ந்தெடுங்கள்',
    visa_validation:'12 இலக்க விசா எண்ணை உள்ளிடவும்',
    enter_vaild_visa:'செல்லுபடியாகும் விசா எண்ணை உள்ளிடவும்',
    please_select_lang:'மொழியைத் தேர்ந்தெடுக்கவும்',
    thank_you:'நன்றி',
    select_feedback:'கருத்தைத் தேர்ந்தெடுக்கவும்',
    feedback_added_success:'கருத்து வெற்றிகரமாக சேமிக்கப்பட்டது'

    
  },
},
te:{
  common:{
    Submit : 'సమర్పించు'
  },
  exit_management :{
    Poor : 'చాలా చెడ్డది',
    Average : 'సరాసరి',
    Good : 'మంచిది',
    Excellent : 'అద్భుతమైనది',
    gro_role : 'హెల్ప్ డెస్క్',
    nurse_role : 'నర్సు స్థాయి',
    xray_role : 'ఎక్స్-రే',
    gp_role : 'ఆలోచన',
    support_role : 'మద్దతు/అధరించిన',
    support_role1 : 'మద్దతు/సహాయం',
    support_role2 : 'సేవలు',
    scan_visa_number:'వీసా నుంబ్ర నిసాాన్ చేయుండి',
    enter_visa_number:'వీసా నుంబ్ర నినమోద్ చేయుండ',
    proceed:'కొనసాగుండి',
    share_your_feedback_to_help_us_improve:'మెరుగుపరచడుంలో మాకు సహాయపడటయనికి మీ అభిప్ార యానిిపుంచ క ుండి',
    choose_language:'భయష్కన ఎుంచ క ుండి',
    select_language:' భయష్కన ఎుంచ క ుండి',
    visa_validation:'12 అంకెల వీసా నంబర్‌ను నమోదు చేయండి',
    enter_vaild_visa:'చెఱకు వాలిడ్ విసా నంబర్ నమోదు చేయండి',
    please_select_lang:'దయచేసి భాషను ఎంచుకోండి',
    thank_you:'ధన్యవాదాలు',
    select_feedback:'దయచేసి అభిప్రాయాన్ని ఎంచుకోండి',
    feedback_added_success:'అభిప్రాయం విజయవంతంగా సేవ్ చేయబడింది'

  },
},
ma: {
  common: {
    Submit: 'സമർപ്പിക്കുക'
  },
  exit_management: {
    Poor: 'മോശം',
    Average: 'ശരാശരി',
    Good: 'നല്ലത്',
    Excellent: 'അത്ഭുതം',
    gro_role: 'സഹായം ടെസ്ക്',
    nurse_role: 'നേഴ്സിംഗ് സ്റ്റേഷൻ',
    xray_role: 'എക്സ്-റേ',
    gp_role: 'ആലോചന',
    support_role: 'സഹായം/അടയാളം',
    support_role1: 'സഹായം/പിന്തുണ',
    support_role2: 'സേവനം',
    scan_visa_number:'സ്കാൻ വിസ നമ്പർ',
    enter_visa_number:'വിസ നമ്പർ നൽകുക ',
    proceed:'തുടരുക',
    share_your_feedback_to_help_us_improve:'മെച്ചപ്പെടുത്താൻ ഞങ്ങളെ സഹായിക്കുന്നതിന് നിങ്ങളുടെ ഫീഡ്‌ബാക്ക് പങ്കിടുക',
    choose_language:'ഭാഷ തിരഞ്ഞെടുക്കുക',
    select_language:'ഭാഷ തിരഞ്ഞെടുക്കുക',
    visa_validation:'12 അക്ക വിസ നമ്പർ നൽകുക',
    enter_vaild_visa:'സാധുവായ വിസ നമ്പര്‍ നല്‍കുക',
    please_select_lang:'ദയവായി ഭാഷ തിരഞ്ഞെടുക്കുക',
    thank_you:'നന്ദി',
    select_feedback:'ദയവായി ഫീഡ്ബാക്ക് തിരഞ്ഞെടുക്കുക ',
    feedback_added_success:'ഫീഡ്‌ബാക്ക് വിജയകരമായി സംരക്ഷിച്ചു'

  },
},
hi: {
  common: {
    Submit: 'प्रस्तुत करें'
  },
  exit_management: {
    Poor: 'खराब',
    Average: 'औसत',
    Good: 'अच्छा',
    Excellent: 'उत्कृष्ट',
    gro_role: 'हेल्प डेस्क',
    nurse_role: 'नर्सिंग स्टेशन',
    xray_role: 'एक्स-रे',
    gp_role: 'जनरल प्रैक्टिशनर',
    support_role: 'समर्थन/सहायता',
    support_role1: 'सहायता/समर्थन',
    support_role2: 'सहयोग',
    scan_visa_number:'वीज़ा नंबर स्कैन करें ',
    enter_visa_number:'वीज़ा नंबर दर्ज करें ',
    proceed:'कृपया आगे बढ़े ',
    share_your_feedback_to_help_us_improve:'हमें बेहतर बनाने में मदद करने के लिए अपनी प्रतिक्रिया साझा करें ',
    choose_language:'भाषा चुनें',
    select_language:'भाषा का चयन करें ',
    visa_validation:'12 अंकों का वीज़ा नंबर दर्ज करें',
    enter_vaild_visa:'वैध वीज़ा नंबर दर्ज करें',
    please_select_lang:'कृपया भाषा चुनें',
    thank_you:'धन्यवाद',
    select_feedback:' कृपया प्रतिक्रिया चुनें ',
    feedback_added_success:'फीडबैक सफलतापूर्वक सहेजा गया'


  },
},
si: {
  common: {
    Submit: 'ඉදිරිපත් කරන්න'
  },
  exit_management: {
    Poor: 'අසාධාරණයක්',
    Average: 'සාමාන්‍ය',
    Good: 'ජයග්‍රහන',
    Excellent: 'ඉතාම ජයග්‍රහනය',
    gro_role: 'සහාය ඡායාරූප',
    nurse_role: 'නර්ස් ස්ථානය',
    xray_role: 'එක්ස්-රේ',
    gp_role: 'සායනය',
    support_role: 'සහාය/උපකරණ',
    support_role1: 'සහාය/සහාය',
    support_role2: 'සහායක්',
    scan_visa_number:'ස්කෑන් වීසා අංකය',
    enter_visa_number:'වීසා අංකය ඇතුලත් කරන්න ',
    proceed:'ඉදිරියට යන්න',
    share_your_feedback_to_help_us_improve:'අපට උදව් කිරීමට ඔබේ ප්‍රතිපෝෂණය බෙදා ගන්න',
    choose_language:'භාෂාව තෝරන්න',
    select_language:'භාෂාව තෝරන්න',
    visa_validation:'ඉලක්කම් 12 වීසා අංකය ඇතුළත් කරන්න',
    enter_vaild_visa:'වලංගු වීසා අංකය ඇතුලත් කරන්න',
    please_select_lang:'කරුණාකර භාෂාව තෝරන්න',
    thank_you:'ස්තූතියි',
    select_feedback:'කරුණාකර ප්‍රතිචාරය තෝරන්න ',
    feedback_added_success:'ප්‍රතිපෝෂණය සාර්ථකව සුරකින ලදී'

  },
},
be: {
  common: {
    Submit: 'জমা দিন'
  },
  exit_management: {
    Poor: 'খারাপ',
    Average: 'গড়',
    Good: 'ভাল',
    Excellent: 'অত্যন্ত ভাল',
    gro_role: 'সহায়তা ডেস্ক',
    nurse_role: 'নার্সিং স্টেশন',
    xray_role: 'এক্স-রে',
    gp_role: 'জেনারেল প্র্যাকটিশনার',
    support_role: 'সহায়তা/সমর্থন',
    support_role1: 'সহায়তা/সাহায্য',
    support_role2: 'সহায়তা',
    scan_visa_number:'ভিসা নম্বর স্ক্যান করুন',
    enter_visa_number:'ভিসা নম্বর লিখুন ',
    proceed:'এগিয়ে যান',
    share_your_feedback_to_help_us_improve:'আপনার মতামত শেয়ার করুন যাতে আমরা উন্নতি করতে পারি',
    choose_language:'ভাষা নির্বাচন করুন',
    select_language:'ভাষা নির্বাচন',
    visa_validation:'12 সংখ্যার ভিসা নম্বর লিখুন',
    enter_vaild_visa:'বৈধ ভিসা নম্বর লিখুন',
    please_select_lang:'ভাষা নির্বাচন করুন অনুগ্রহ করে',
    thank_you:'ধন্যবাদ',
    select_feedback:'দয়া করে প্রতিক্রিয়া নির্বাচন করুন ',
    feedback_added_success:'প্রতিক্রিয়া সফলভাবে সংরক্ষণ করা হয়েছে'

    
  },
},
mi: {
  common: {
    Submit: 'सबमिट करा'
  },
  exit_management: {
    Poor: 'खराब',
    Average: 'सरासरी',
    Good: 'चांगले',
    Excellent: 'उत्कृष्ट',
    gro_role: 'सहाय्य डेस्क',
    nurse_role: 'नर्सिंग स्टेशन',
    xray_role: 'एक्स-रे',
    gp_role: 'जनरल प्रॅक्टिशनर',
    support_role: 'समर्थन/सहाय्य',
    support_role1: 'सहाय्य/सामर्थ्य',
    support_role2: 'संबंधी सहाय्य',
    scan_visa_number:'व्हिसा क्रमांक स्कॅन करा ',
    enter_visa_number:'क्रमांकाद्वारे प्रविष्ट करा',
    proceed:'पुढे जा ',
    share_your_feedback_to_help_us_improve:'आम्हाला सुधारण्यात मदत करण्यासाठी तुमचा अभिप्राय शेअर करा ',
    choose_language:'भाषा निवडा ',
    select_language:'भाषा निवडा ',
    visa_validation:'12 अंकी व्हिसा क्रमांक प्रविष्ट करा',
    enter_vaild_visa:'वैध व्हिसा नंबर प्रविष्ट करा ',
    please_select_lang:'कृपया भाषा निवडा',
    thank_you:'धन्यवाद',
    select_feedback:'कृपया प्रतिसाद निवडा',
    feedback_added_success:'अभिप्राय यशस्वीरित्या जतन केला'


  },
},
fi: {
  common: {
    Submit: 'Ipasa'
  },
  exit_management: {
    Poor: 'Hindi Maganda',
    Average: 'Karaniwan',
    Good: 'Maganda',
    Excellent: 'Napakaganda',
    gro_role: 'Tulong Desk',
    nurse_role: 'Nursing Station',
    xray_role: 'X-Ray',
    gp_role: 'General Practitioner',
    support_role: 'Suporta/Tulong',
    support_role1: 'Suporta/Tulong',
    support_role2: 'Suporta',
    scan_visa_number:'Iscan ang Visa Number',
    enter_visa_number:'Itype ang Visa Number ',
    proceed:'Magpatuloy',
    share_your_feedback_to_help_us_improve:'Ibahagi ang iyong Feedback upang matulungan kaming mapabuti',
    choose_language:'Piliin ang nais na wika',
    select_language:'Magpatuloy',
    visa_validation:'Ipasok ang 12 digit na Numero ng visa',
    enter_vaild_visa:'Maglagay ng wastong numero ng visa',
    please_select_lang:'Mangyaring pumili ng wika',
    thank_you:'Salamat',
    select_feedback:'Mangyaring pumili ng feedback ',
    feedback_added_success:'Matagumpay na na-save ang feedback'

  },
},
ur: {
    common: {
      Submit: 'جمع کرائیں'
    },
    exit_management: {
      Poor: 'خراب',
      Average: 'اوسط',
      Good: 'اچھا',
      Excellent: 'شاندار',
      gro_role: 'ہیلپ ڈیسک',
      nurse_role: 'نرس اسٹیشن',
      xray_role: 'ایکس رے',
      gp_role: 'مشاورت',
      support_role: 'سیکیورٹی / فلور',
      support_role1: 'سپورٹ / فیسلٹی',
      support_role2: 'خدمت',
      scan_visa_number: 'ویزا نمبر سکین کریں',
      enter_visa_number: 'ویزا نمبر درج کریں',
      proceed: 'آگے بڑھیں',
      share_your_feedback_to_help_us_improve: 'ہمیں بہتر بنانے کے لئے اپنی رائے شیئر کریں',
      choose_language: 'زبان منتخب کریں',
      select_language: 'زبان منتخب کریں',
      visa_validation: '12 ڈیجیٹ ویزا نمبر درج کریں',
      enter_vaild_visa: 'درست ویزا نمبر درج کریں',
      please_select_lang: 'براہ کرم زبان منتخب کریں',
      thank_you: 'شکریہ',
      select_feedback: 'براہ کرم تاثر منتخب کریں',
      feedback_added_success:'تاثرات کامیابی کے ساتھ محفوظ ہو گئے۔'
    }
  },


  ne: {
    common: {
      Submit: 'पेश गर्नुहोस्'
    },
    exit_management: {
      Poor: 'खराब',
      Average: 'साधारण',
      Good: 'राम्रो',
      Excellent: 'उत्कृष्ट',
      gro_role: 'सहायता डेस्क',
      nurse_role: 'नर्स स्टेशन',
      xray_role: 'एक्स-रे',
      gp_role: 'परामर्श',
      support_role: 'सुरक्षा/मंजिल',
      support_role1: 'समर्थन/सुविधा',
      support_role2: 'सेवा',
      scan_visa_number: 'भिसा नम्बर स्क्यान गर्नुहोस्',
      enter_visa_number: 'भिसा नम्बर लेख्नुहोस्',
      proceed: 'अगाडी बढ्नुहोस्',
      share_your_feedback_to_help_us_improve: 'हामीलाई सुधार गर्न मद्दत गर्नका लागि आफ्नो प्रतिक्रिया साझा गर्नुहोस्',
      choose_language: 'भाषा छनौट गर्नुहोस्',
      select_language: 'भाषा छनौट गर्नुहोस्',
      visa_validation: '१२ अंकको भिसा नम्बर लेख्नुहोस्',
      enter_vaild_visa: 'मान्य भिसा नम्बर लेख्नुहोस्',
      please_select_lang: 'कृपया भाषा छनौट गर्नुहोस्',
      thank_you: 'धन्यवाद',
      select_feedback: 'कृपया प्रतिक्रिया छनौट गर्नुहोस्',
      feedback_added_success:'प्रतिक्रिया सफलतापूर्वक सुरक्षित गरियो'
    }
  }


};



